import { setAuthenticator } from '@ms/yammer-data/dist/authentication';
import { getPersistedExperimentTreatment } from '@ms/yammer-data/dist/domains/experiments/selectors';
import { Experiment, NetworkType } from '@ms/yammer-data/dist/state/types';
import { ErrorCode, reportError } from '@ms/yammer-data/dist/telemetry';
import { AdalPopupAuthenticator, AuthenticatorType, PopupAuthenticator } from '@ms/yammer-web-authenticators';
import { getNetworkContext } from '@ms/yammer-web-support/dist/location';

import config from '../config';
import { persistConfig } from '../persistedState';

const getAuthenticator = async (isMsal: boolean) => {
  const networkContext = getNetworkContext(window.location.pathname);

  try {
    if (isMsal) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (config as any).adal = config.msal;
      const tenant =
        networkContext?.networkType === NetworkType.Canonical ? networkContext.permalink : config.msal.tenant;

      const { default: MsalPopupAuthenticator } = await import(
        /* webpackChunkName: "4-auth-msal" */ '@ms/yammer-web-authenticators/dist/embed/MsalPopupAuthenticator'
      );

      return new MsalPopupAuthenticator({ ...config.msal, tenant });
    }
  } catch (error) {
    reportError({
      error,
      eventProperties: {
        authenticatorType: AuthenticatorType.MsalPopup,
        errorCode: ErrorCode.AuthenticatorLoadFailed,
      },
    });
  }

  const tenant = networkContext?.networkType === NetworkType.Canonical ? networkContext.permalink : config.adal.tenant;

  return new AdalPopupAuthenticator({ ...config.adal, extraQueryParameters: 'login_hint', tenant });
};

export type SetupAuthenticator = () => Promise<PopupAuthenticator>;
export const setupAuthenticator: SetupAuthenticator = async () => {
  const isMsal = (await getPersistedExperimentTreatment(persistConfig.key, Experiment.EmbedMsal)) as boolean;

  const authenticator = await getAuthenticator(isMsal);
  setAuthenticator(authenticator);

  return authenticator;
};
